<template>
    <div>
        <breadCrumb 
            :icon="'fa-boxes'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_stock`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="selectedTab === 'stockBalance'" class="row mt-3">
            <div class="col-sm-6 col-xl-3" v-for="box in stockBalanceReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.stockTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <stockBalance :class="{'active': selectedTab === 'stockBalance'}" class="tab-pane" @getInventory="getInventory" @refreshStockList="refreshStockList" @updateStockBalanceSummaryBox="updateStockBalanceSummaryBox"></stockBalance>
            <stockList ref="stockList" :class="{'active':selectedTab === 'stockList'}" class="tab-pane" :status="'stockList'" :productItems="productItems"></stockList>
            <stockList ref="in" :class="{'active': selectedTab === 'in'}" class="tab-pane" :status="'in'"  :productItems="productItems"></stockList>
            <stockList ref="out" :class="{'active': selectedTab === 'out'}" class="tab-pane" :status="'out'" :productItems="productItems"></stockList>
        </div>
        <div :class="{'show': inventoryToggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-lg modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('salon_report.stock.header_inventory')}}
                            <small class="m-0 text-muted">{{stockTitle}}</small>
                        </h5>
                        <button type="button" class="close" @click="inventoryToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <inventory ref="inventory"></inventory>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import Inventory from './Inventory'
import StockList from './Stock_List'
import StockBalance from './Stock_Balance'
import box from './../../../../assets/js/dashboard/salonReport/salonReport'
import {handleSessionExpired, setSummaryBoxLabel} from './../../../../assets/js/dashboard/dashboard.js'
export default {
    name: 'stock',
    components:{
        StockList, StockBalance, Inventory, BreadCrumb
    },
    data(){
        return{
            selectedTab: "stockBalance",
            stockBalanceReportSummaryBox: [],
            productItems: {},
            inventoryToggleModal: false, stockTitle: ""
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setSummaryBoxLabel()
        },
        selectedTab(val){
            if(val != 'stockBalance'){
                this.$refs[val].loadData()
            }
        },
    },
    methods:{
        refreshStockList(){
            this.getProductItem()
        },
        getProductItem(){
            let $vm = this
            let QUERY_STRING =  "?type=product"
            // const url =  this.$api.MENU_ITEM + QUERY_STRING;
            const url ='https://menu.tunai.io/business/sku?typeID=2'

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.productItems = {};
                for(let sku of response.data.skus) {
                    $vm.productItems[sku['skuID']] = sku
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        getInventory(id, title, outletID){
            this.inventoryToggleModal = true;
            this.stockTitle = title;
            this.$refs.inventory.getInventory(outletID, id);
        },
        updateStockBalanceSummaryBox(data){
            for(var i=0; i<this.stockBalanceReportSummaryBox.length; i++){
                switch(this.stockBalanceReportSummaryBox[i].id){
                    case"price_inventory":
                        this.stockBalanceReportSummaryBox[i].value = data.priceInventory;
                        break
                    case"cost_inventory":
                        this.stockBalanceReportSummaryBox[i].value = data.costInventory;
                        break
                }
            }
        },
        setSummaryBoxLabel(){
            var _box = box.stockBalanceReportSummaryBox
            this.stockBalanceReportSummaryBox = setSummaryBoxLabel(this, 'stock', _box.slice())
        },
    },
    mounted(){
        let $vm = this;
        $vm.getProductItem()
        $vm.setSummaryBoxLabel()
    }
}

</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
.modal-lg{
    max-width: 60vw;
}
.modal-body-lg{
    min-height: 60vh;
    max-height: 80vh;
    overflow-y: auto;
}
</style>
